export default __webpack_public_path__ + "static/media/manager.8af96082.png";